
export default {
  allEndUseSorts: (state) => state.endUseSorts,
  endUseSortsLoading: (state) => state.endUseSortsLoading
}
